import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import axios from "@/libs/api.request";
import { common } from "./api_url";
/**
 * 获取通讯组列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var GetCustomerSourceList = function GetCustomerSourceList(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.GetCustomerSourceList,
    params: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "get"
  });
};
/**
 * 获取所有枚举
 * @param data
 * @returns {*|{responseURL}}
 */

export var getAllEnumType = function getAllEnumType(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.getAllEnumType,
    params: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "get"
  });
};
export var GetImportDepartment = function GetImportDepartment(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.GetImportDepartment,
    params: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "get"
  });
};
export var QueryCustomerAptitudeLevel = function QueryCustomerAptitudeLevel(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.QueryCustomerAptitudeLevel,
    params: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "get"
  });
};
/**
 * 上传文件
 * @param data
 * @param contentType
 * @returns {*|{responseURL}}
 */

export var UploadFile = function UploadFile(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.UploadFile,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  }, "FormData");
};
/**
 * 获取文件
 * @param data
 * @returns {*|{responseURL}}
 * @constructor
 */

export var GetFile = function GetFile(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.GetFile,
    params: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "get"
  });
};
/**
 * 回复反馈
 */

export var ReplyFeedback = function ReplyFeedback(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.ReplyFeedback,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 查询反馈列表
 */

export var QueryFeedback = function QueryFeedback(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.QueryFeedback,
    params: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "get"
  });
};
/**
 * 根据部门Id 获取部门的下一级部门列表和部门及下属所有部门的人员信息
 */

export var GetChildDeptAndAllPerson = function GetChildDeptAndAllPerson(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.GetChildDeptAndAllPerson,
    params: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "get"
  });
};
/**
 * 获得组织树
 * @param data
 * @returns {*|{responseURL}}
 * @constructor
 */

export var GetDeptTree = function GetDeptTree(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.GetDeptTree,
    params: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "get"
  });
};
/**
 * 请求接口公用
 * @param {*} url
 * @param {*} data
 * @returns
 */

export var commonReq = function commonReq(url, data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: url,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};